module.exports = __webpack_public_path__ + "static/media/mug.b147bc35.svg";